import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { DeclineAirbnbBookingDialogComponent } from './decline-airbnb-booking-dialog.component'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { Rental } from '@tokeet/tv3-platform'

@Injectable()
export class DeclineAirbnbBookingDialogService {
  constructor(private dialog: MatDialog) {}

  open(inquiry: Inquiry, rental: Rental) {
    let defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { inquiry, rental },
    }

    return this.dialog.open(DeclineAirbnbBookingDialogComponent, defaultConfig)
  }
}
